import React from 'react';
import { useStepsContext } from '../../StepsContext';
import { DefaultBanner } from './image/DefaultBanner';
import { ProfileBanner } from './image/ProfileBanner';
import { TeamBanner, TeamBannerInvitation } from './image/TeamBanner';
import { CodeActivationBanner } from './image/CodeActivationBanner';

export const StepBanner = () => {
    const { activeStepId } = useStepsContext();

    switch (activeStepId) {
        case 'profile_setup':
        case 'reset_password':
        case 'change_email': {
            return <ProfileBanner />;
        }
        case 'business_info':
            return <TeamBanner />;
        case 'invitation':
            return <TeamBannerInvitation />;
        case 'code_activation': {
            return <CodeActivationBanner />;
        }
        default:
            return <DefaultBanner />;
    }
};
